var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"nonzero","fill":"none"},React.createElement("path",{"fill":"#11D08A","d":"M19 5.6L20.4 7 9 18.4 3.6 13 5 11.6l4 4z"})));
}

Check.defaultProps = {"width":"24","height":"24","viewBox":"0 3 20 18"};

module.exports = Check;

Check.default = Check;
